import withPageTitle from "../../../routes/containers/withPageTitle"
import UserAgreement from "../components/UserAgreement"

export default withPageTitle("User Agreement")(UserAgreement)
